import { Skeleton } from 'antd';

import { Card, CardContent, CardHeader } from '../../../components/ui/card';
import { AvailablePlatform } from '../../../services/users';
import { PLATFORM_CONFIGS } from './constants';
import { PlatformCard } from './PlatformCard';

type PlatformGridProps = {
  platforms: AvailablePlatform[];
  loading?: boolean;
};

export const PlatformGrid = ({ platforms, loading = false }: PlatformGridProps): JSX.Element => {
  if (loading) {
    return (
      <div className="flex flex-col gap-4 sm:grid sm:grid-cols-[repeat(auto-fill,minmax(min(100%,280px),1fr))]">
        {[1, 2, 3].map((index) => (
          <Card key={index} className="h-full rounded-2xl border border-gray-200 shadow-sm">
            <CardHeader>
              <div className="flex justify-center mb-5">
                <Skeleton.Avatar active size={72} shape="square" />
              </div>
              <Skeleton active paragraph={{ rows: 1 }} />
            </CardHeader>
            <CardContent>
              <Skeleton.Button active block size="large" />
            </CardContent>
          </Card>
        ))}
      </div>
    );
  }

  return (
    <div className="flex flex-col gap-4 sm:grid sm:grid-cols-[repeat(auto-fill,minmax(min(100%,280px),1fr))]">
      {platforms.map((platform) => {
        const config =
          platform.key in PLATFORM_CONFIGS
            ? PLATFORM_CONFIGS[platform.key]
            : {
                name: platform.key,
                icon: '/images/platforms/default.svg'
              };

        return <PlatformCard key={platform.key} config={config} url={platform.url} />;
      })}
    </div>
  );
};
